import * as ng from 'angular';
import {ArchiSmallServices} from '../../../services/archismall.service';
import {googleAPI} from '../../../third/googleAPI';

class ChangePersonalFilesController implements ng.IController {

  static $inject: string[] = [
    '$scope',
    '$rootScope',
    'ArchiSmallServices',
    '$timeout',
    '$uibModalStack',
    '$sce',
    'configuration'
  ];

  private close: any;
  private dismiss: any;

  constructor(
    private $scope: any,
    private $rootScope: any,
    private ArchiSmallServices: ArchiSmallServices,
    private $timeout: ng.ITimeoutService,
    private $uibModalStack: ng.ui.bootstrap.IModalStackService,
    private $sce: ng.ISCEService,
    private configuration: any
  ) {
    $scope.tooltips = {
      'identityCard': 'Carica copia a colori fronte/retro del documento d\'identità valido (Carta o Passaporto) del Legale Rappresentante.',
      'fiscalCode': 'Carica copia a colori fronte/retro del Codice Fiscale del Legale Rappresentante.',
      'businessProfile': 'Carica copia a norma della Visura Camerale valida.'
    };
    $scope.disableSaving = false;
    $scope.user = $scope.$parent.$resolve.user;
    $scope.acceptedExtensions = ['pdf', 'jpg', 'png'];
    $scope.identityCardFileRequiredError = false;
    $scope.identityCardLoading = false;
    $scope.fiscalCodeLoading = false;
    $scope.businessProfileLoading = false;
    $scope.type = '';

    $scope.ok = () => {
      this.close();
    };

    $scope.cancel = () => {
      $scope.user.organizationData.contactPerson.identityCardFile = $scope.identityCardFileCopy === 'Allega copia Carta Identita' ? '' : $scope.identityCardFileCopy;
      $scope.user.organizationData.contactPerson.fiscalCodeFile = $scope.fiscalCodeFileCopy === 'Allega copia Codice Fiscale' ? '' : $scope.fiscalCodeFileCopy;
      $scope.user.organizationData.contactPerson.businessProfileFile = $scope.businessProfileFileBefore === 'Allega copia Visura Camerale' ? '' : $scope.businessProfileFileBefore;
      this.dismiss({$value: 'cancel'});
    };

    let cleanModelFromDescription = () => {
      if ($scope.user.organizationData.contactPerson.identityCardFile === 'Allega copia Carta Identita') {
        $scope.user.organizationData.contactPerson.identityCardFile = '';
      }

      if ($scope.user.organizationData.contactPerson.fiscalCodeFile === 'Allega copia Codice Fiscale') {
        $scope.user.organizationData.contactPerson.fiscalCodeFile = '';
      }

      if ($scope.user.organizationData.contactPerson.businessProfileFile === 'Allega copia Visura Camerale') {
        $scope.user.organizationData.contactPerson.businessProfileFile = '';
      }
    };

    $scope.uploadFileDescription = 'Clicca qui per allegare il tuo documento.';
    $scope.user.organizationData.contactPerson.identityCardFile = $scope.user.organizationData.contactPerson.identityCardFile === undefined ? '' : $scope.user.organizationData.contactPerson.identityCardFile;
    $scope.user.organizationData.contactPerson.fiscalCodeFile = $scope.user.organizationData.contactPerson.fiscalCodeFile === undefined ? '' : $scope.user.organizationData.contactPerson.fiscalCodeFile;
    $scope.user.organizationData.contactPerson.businessProfileFile = $scope.user.organizationData.contactPerson.businessProfileFile === undefined ||
    $scope.user.organizationData.contactPerson.businessProfileFile === '' ?
      '' : $scope.user.organizationData.contactPerson.businessProfileFile;

    cleanModelFromDescription();
    $scope.identityCardFileCopy = $scope.user.organizationData.contactPerson.identityCardFile;
    $scope.fiscalCodeFileCopy = $scope.user.organizationData.contactPerson.fiscalCodeFile;
    $scope.businessProfileFileBefore = $scope.user.organizationData.contactPerson.businessProfileFile;

    $scope.fiscalCodeFile = '';
    $scope.fiscalCodeFileId = '';
    $scope.fiscalCodeFilePath = '';
    $scope.identityCardFile = '';
    $scope.identityCardFileId = '';
    $scope.identityCardFilePath = '';
    $scope.businessProfileFile = '';
    $scope.businessProfileFileId = '';
    $scope.businessProfileFilePath = '';
    $scope.changedFieldFiscal = false;
    $scope.changedFieldIdentity = false;
    $scope.changedFieldBusinessProfile = false;
    $scope.changedSuccess = false;

    $scope.uploadFileOnGoogleStorageCallback = (dropzoneId, res, filename) => {
      let icon = '';
      let delete_icon = '';
      $scope.extension = filename.split('.').pop().toLowerCase();
      delete_icon = '<a ng-click=\'deleteFile($event)\'><i class=\'fa fa-trash-o fa-2x delete-icon\'></i></a>';

      switch ($scope.extension) {
        case 'pdf':
          icon = $sce.trustAsHtml('<i class=\'fa fa-file-pdf-o fa-2x\'></i>');
          break;
        case 'jpg':
        case 'png':
          icon = $sce.trustAsHtml('<i class=\'fa fa-file-image-o fa-2x\'></i>');
          break;
        default:
          icon = $sce.trustAsHtml('<i class=\'fa fa-file-o fa-2x\'></i>');
      }

      if (dropzoneId === 'dropzone-fiscal-code') {
        $scope.user.organizationData.contactPerson.fiscalCodeFile = filename;
        $scope.user.organizationData.contactPerson.fiscalCodeFileId = res.id.split('/')[0] + '/' + res.name;
        $scope.fiscalCodeFile = filename;
        $scope.fiscalCodeFileId = res.id;
        $scope.fiscalCodeFilePath = res.name;
        $scope.icon_fiscal_code = icon;
        $scope.delete_fiscal_code = delete_icon;
        $scope.changedFieldFiscal = true;
      } else if (dropzoneId === 'dropzone-business-profile') {
        $scope.user.organizationData.contactPerson.businessProfileFile = filename;
        $scope.user.organizationData.contactPerson.businessProfileFileId = res.id.split('/')[0] + '/' + res.name;
        $scope.businessProfileFile = filename;
        $scope.businessProfileFileId = res.id;
        $scope.businessProfileFilePath = res.name;
        $scope.icon_business_profile = icon;
        $scope.delete_business_profile_file = delete_icon;
        $scope.changedFieldBusinessProfile = true;
      } else {
        $scope.user.organizationData.contactPerson.identityCardFile = filename;
        $scope.user.organizationData.contactPerson.identityCardFileId = res.id.split('/')[0] + '/' + res.name;
        $scope.identityCardFile = filename;
        $scope.identityCardFileId = res.id;
        $scope.identityCardFilePath = res.name;
        $scope.icon_id_card = icon;
        $scope.delete_id_card_file = delete_icon;
        $scope.changedFieldIdentity = true;
        $scope.identityCardFileRequiredError = false;
      }

      $scope.id_card_placeholder = '';
      $scope.disableSaving = false;
      $scope.showHideSpecificLoadingIcon($scope.type);
    };

    let deleteInputFile = (id) => {
      let element = ng.element(document.querySelector(id));
      ng.element(element).val(null);
    };

    $scope.deleteFile = (type) => {
      let inputId = $scope.getIdByType(type);
      deleteInputFile(inputId);
      let dropzoneId = $scope.getDropzoneIdByType(type);

      if (dropzoneId === 'dropzone-fiscal-code') {
        $scope.user.organizationData.contactPerson.fiscalCodeFileId = '';
        $scope.user.organizationData.contactPerson.fiscalCodeFile = '';
        $scope.fiscalCodeFile = '';
        $scope.fiscalCodeFileId = '';
        $scope.fiscalCodeFilePath = '';
        $scope.icon_fiscal_code = '';
        $scope.delete_fiscal_code = '';
        $scope.changedFieldFiscal = false;
      } else if (dropzoneId === 'dropzone-business-profile') {
        $scope.user.organizationData.contactPerson.businessProfileFileId = '';
        $scope.user.organizationData.contactPerson.businessProfileFile = '';
        $scope.businessProfileFile = '';
        $scope.businessProfileFileId = '';
        $scope.businessProfileFilePath = '';
        $scope.icon_business_profile = '';
        $scope.delete_business_profile_file = '';
        $scope.changedFieldBusinessProfile = false;
      } else {
        $scope.user.organizationData.contactPerson.identityCardFileId = '';
        $scope.user.organizationData.contactPerson.identityCardFile = '';
        $scope.identityCardFile = '';
        $scope.identityCardFileId = '';
        $scope.identityCardFilePath = '';
        $scope.icon_id_card = '';
        $scope.delete_id_card_file = '';
        $scope.changedFieldIdentity = false;
      }
    };

    $scope.updateFiles = () => {
      $scope.files = {};
      if ($scope.fiscalCodeFile !== '') {
        $scope.files.fiscalCode = {
          'fileName': $scope.user.organizationData.contactPerson.fiscalCodeFile,
          'fileId': $scope.user.organizationData.contactPerson.fiscalCodeFileId,
          'changed': $scope.fiscalCodeFileCopy !== $scope.user.organizationData.contactPerson.fiscalCodeFile
        };
      }
      if ($scope.identityCardFile !== '') {
        $scope.files.identityCard = {
          'fileName': $scope.user.organizationData.contactPerson.identityCardFile,
          'fileId': $scope.user.organizationData.contactPerson.identityCardFileId,
          'changed': $scope.identityCardFileCopy !== $scope.user.organizationData.contactPerson.identityCardFile
        };
      }
      if ($scope.businessProfileFilePath !== '') {
        $scope.files.businessProfile = {
          'fileName': $scope.user.organizationData.contactPerson.businessProfileFile,
          'fileId': $scope.user.organizationData.contactPerson.businessProfileFileId,
          'changed': $scope.businessProfileFileBefore !== $scope.user.organizationData.contactPerson.businessProfileFile
        };
      }

      let promise = ArchiSmallServices.updatePersonalFiles($scope.files)
        .then((response: any) => {
          $scope.changedSuccess = true;
          $scope.user.organizationData.contactPerson.fiscalCodeFileId = response.organizationData.contactPerson.fiscalCodeFileId;
          $scope.user.organizationData.contactPerson.fiscalCodeFile = response.organizationData.contactPerson.fiscalCodeFile;
          $scope.user.organizationData.contactPerson.identityCardFileId = response.organizationData.contactPerson.identityCardFileId;
          $scope.user.organizationData.contactPerson.identityCardFile = response.organizationData.contactPerson.identityCardFile;
          $scope.user.organizationData.contactPerson.businessProfileFile = response.organizationData.contactPerson.businessProfileFile;
          $scope.user.organizationData.contactPerson.businessProfileFileId = response.organizationData.contactPerson.businessProfileFileId;

        }, (error) => {
          $rootScope.alert('error', error);
          $scope.cancel();
        });
      return promise;
    };

    $scope.save = () => {
      $scope.identityCardFileRequiredError = $scope.user.organizationData.contactPerson.identityCardFile === undefined ||
        $scope.user.organizationData.contactPerson.identityCardFile === '' ||
        $scope.user.organizationData.contactPerson.identityCardFile === 'Allega copia Carta Identita';

      if ($scope.identityCardFileRequiredError) {
        return;
      }

      let data = {
        'user': $scope.user,
        'requiredFieldsMissing': $scope.identityCardFileRequiredError,
        'changed': {
          'identityCard': $scope.identityCardFileCopy !== $scope.user.organizationData.contactPerson.identityCardFile,
          'fiscalCode': $scope.fiscalCodeFileCopy !== $scope.user.organizationData.contactPerson.fiscalCodeFile,
          'businessProfile': $scope.businessProfileFileBefore !== $scope.user.organizationData.contactPerson.businessProfileFile
        }
      };

      this.close({$value: data});
    };

    $scope.startInputUpload = (type) => {
      let idSelector = $scope.getIdByType(type);
      $(idSelector).trigger('click');
    };

    $scope.getIdByType = (type) => {
      let idSelector = '';

      switch (type) {
        case 'identityCard':
          idSelector = '#identity-card-upload';
          break;
        case 'fiscalCode':
          idSelector = '#fiscal-code-upload';
          break;
        case 'businessProfile':
          idSelector = '#business-profile-upload';
          break;
      }

      return idSelector;
    };

    $scope.getDropzoneIdByType = (type) => {
      let dropzoneId = '';

      switch (type) {
        case 'identityCard':
          dropzoneId = 'dropzone-id-cards';
          break;
        case 'fiscalCode':
          dropzoneId = 'dropzone-fiscal-code';
          break;
        case 'businessProfile':
          dropzoneId = 'dropzone-business-profile';
          break;
      }

      return dropzoneId;
    };

    $scope.inputUpload = (input, type) => {
      let file = input.files[0];
      if ($scope.isExtensionAccepted(file)) {
        $scope.type = type;
        $scope.showHideSpecificLoadingIcon(type);
        $scope.disableSaving = true;
        let username = $scope.user.accountData.email;
        let dropzoneId = $scope.getDropzoneIdByType(type);
        $scope.uploadFileOnGoogleStorage(file, username, dropzoneId);
      }
    };

    $scope.isExtensionAccepted = (file) => {
      let extension = file.name.split('.').pop().toLowerCase();

      if ($.inArray(extension, $scope.acceptedExtensions) === -1) {
        $rootScope.alert('warning', 'Il file <b>' + file.name + '</b> non può essere accettato! (I soli formati permessi sono: <b>' + $scope.acceptedExtensions.join(', ') + '</b>)');
        return false;
      }

      return true;
    };

    let insertObject = (file, username, dropzoneId) => {
      let dropzoneStorageFolder = 'users/' + $scope.user.accountData.email + '/personal_files';
      ArchiSmallServices.validateGoogleAPIToken(googleAPI.getAccessToken())
        .then((response: any) => {
          googleAPI.insertObject(file, dropzoneId, dropzoneStorageFolder, username, $scope.uploadFileOnGoogleStorageCallback);
          $rootScope.filesUploadedNumber++;
        }, (error) => {
          ArchiSmallServices.getGoogleAPIToken()
            .then((response: any) => {
              googleAPI.setAccessToken(response.accessToken);
              googleAPI.insertObject(file, dropzoneId, dropzoneStorageFolder, username, $scope.uploadFileOnGoogleStorageCallback);
              $rootScope.filesUploadedNumber++;
            }, (error) => {
              $rootScope.alert('error', error);
              $scope.disableSaving = false;
              $scope.showHideSpecificLoadingIcon($scope.type);
            });
        });
    };

    $scope.uploadFileOnGoogleStorage = (file, username, dropzoneId) => {

      // user max upload size check
      if ((file.size / 1024 / 1024) > $scope.user.limits.maxFileSizeOnUploadMB) {
        $rootScope.alert('error', 'Il file ' + file.name + ' supera il limite di dimensione massimo consentito per l\'upload un singolo file (' + $scope.user.limits.maxFileSizeOnUploadMB + ' MB). Se desideri incrementare questo limite puoi contattare il supporto ArchiSMALL.');
        return;
      }

      // usage Percentage check
      ArchiSmallServices.getStorageUsage()
        .then((response: any) => {
          $rootScope.storageUsage = response;

          if (response.subscriptionCancelled) {
            $rootScope.alert('error', 'You can\'t upload files, because your subscription is cancelled');
            $scope.disableSaving = false;
            $scope.showHideSpecificLoadingIcon($scope.type);
            return;
          }

          if ($rootScope.storageUsage.usagePercentage >= 100 && $rootScope.storageUsage.isBlockUser) {
            $rootScope.alert('error', 'Hai esaurito lo spazio a disposizione (' + $rootScope.storageUsage.availableSpace + '). Richiedei un incremento di spazio contattando il supporto ArchiSMALL.');
            $scope.disableSaving = false;
            $scope.showHideSpecificLoadingIcon($scope.type);
            return;
          }

          insertObject(file, username, dropzoneId);
        }, (error) => {
          $rootScope.alert('error', error);
          $scope.disableSaving = false;
          $scope.showHideSpecificLoadingIcon($scope.type);
        });
    };

    $scope.showHideSpecificLoadingIcon = (type) => {
      switch (type) {
        case 'identityCard':
          $scope.identityCardLoading = !$scope.identityCardLoading;
          break;
        case 'fiscalCode':
          $scope.fiscalCodeLoading = !$scope.fiscalCodeLoading;
          break;
        case 'businessProfile':
          $scope.businessProfileLoading = !$scope.businessProfileLoading;
          break;
      }
    };
  }
}

export const ChangePersonalFilesComponent: ng.IComponentOptions = {
  template: require('./change-personal-files.html'),
  controller: ChangePersonalFilesController,
  bindings: {
    close: '&',
    dismiss: '&'
  }
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/usersettings/change-personal-files/change-personal-files.ts